module.exports = __webpack_public_path__ + "static/media/CHOPV_MENU-normal.c6bed9df.png";